import { CORS_PROXY_URL } from 'constants/calendars'

export const getEventSource = (icsUrl: string) => {
  return CORS_PROXY_URL + encodeURIComponent(icsUrl)

  // Uncomment this line to force a cache refresh using epoch timestamp
  // return CORS_PROXY_URL + encodeURIComponent(icsUrl) + '/' + DateTime.local().toMillis()
}
